import React from 'react'
import withReduxModal from '../../../modules/redux-modal/redux/withReduxModal'
import { SHOW_QRCODE_MODAL } from '../../../constants/modalType'

function QRCodeButton({ modalActions, title, text, imageID }) {
  function handleQrSelect(e) {
    e.stopPropagation()

    modalActions.showModal(SHOW_QRCODE_MODAL, {
      text,
      title: title || `QR CODE`,
      imageID
    })
  }

  return (
    <div className="button" onClick={handleQrSelect}>
      <span className="icon">
        <i className="fas fa-qrcode" />
      </span>
      <span> QR </span>
    </div>
  )
}

export default withReduxModal(QRCodeButton)



// WEBPACK FOOTER //
// ./src/components/templates/qrcode/QRCodeButton.js